import "./ScrollContainer.scss";

const ScrollContainer = ({height = "150vh", children, id}) => <div className={"scroll-container"} id={id}
                                                               style={{height: height}}>{children}</div>
export default ScrollContainer;